<div class="container">
  <mat-toolbar>
    <span>
      <h3> New Data Profile</h3>
    </span>
  </mat-toolbar>
  <mat-card>
    <mat-card-content>
      <form name="newProfileForm" [formGroup]="form" (ngSubmit)="addProfile(form.value)" class="example-form">

        <!-- <div class="form-row">
          <label class="space label"> Existing Profiles </label>

          <mat-form-field class="form-field">
            <mat-label> Select Profile </mat-label>
            <mat-select formControlName="profilelist" (selectionChange)="onProfileChange($event)">
              <mat-option [value]="null">None</mat-option>
              @for (profile of profilelist; track profile) {
              <mat-option [value]="profile.id">{{ profile.name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div> -->

        <br />
        <br />
        <div class="form-row">
          <label class="space label">Profile Name </label>

          <mat-form-field class="form-field">
            <input matInput name="name" formControlName="name" [formGroup]="form" required>
          </mat-form-field>
        </div>
        <br />
        <br />
        <div class="form-row">
          <label class="space label"> Description </label>

          <mat-form-field class="form-field">
            <textarea matInput name="description" formControlName="description" rows="4" required>
  </textarea>
          </mat-form-field>
        </div>
        <br />
        <br />
        <div class="form-row">
          <label class="space label"> Schema File </label>

          <input type="file" matTooltip="Add Attachment" hidden ng2FileSelect #file [uploader]="uploader" multiple
            required />
          <button type="button" class="material-icons spacer" (click)="file.click()">
            &#xE226;</button>
        </div>
        <br />
        <br />
        <div class="selectedfiles">
          <div *ngFor="let item of uploader.queue" height="300">
            {{ item?.file?.name }}
            <button mat-icon-button (click)="remove(item)">
              <i class="material-icons">delete</i></button>
          </div>
        </div>
        <br />
        <mat-card-actions class="buttonspace">
          <button type="submit" mat-raised-button color="primary" [disabled]="!form.valid || form.pristine">
            Create Profile
          </button>

          <!-- <button type="button" mat-raised-button color="primary" (click)="duplicateProfile()"
            [disabled]="!isProfileSelected || !form.valid || form.pristine">
            Duplicate Profile
          </button> -->
          <button mat-raised-button mat-button color="primary" type="reset" (click)="clear()">
            Reset
          </button>
        </mat-card-actions>
      </form>

    </mat-card-content>

  </mat-card>